var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter 1",
    clipPath: "url(#clip0_4238_47543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 4.17863C21.1819 4.5375 20.3101 4.77537 19.4012 4.89087C20.3363 4.33262 21.0499 3.45537 21.3854 2.398C20.5136 2.91775 19.5511 3.28488 18.5254 3.48975C17.6976 2.60838 16.5179 2.0625 15.2309 2.0625C12.7339 2.0625 10.7236 4.08925 10.7236 6.57388C10.7236 6.93138 10.7539 7.27512 10.8281 7.60237C7.0785 7.4195 3.76063 5.62238 1.53175 2.88475C1.14262 3.55988 0.914375 4.33262 0.914375 5.1645C0.914375 6.7265 1.71875 8.11112 2.91775 8.91275C2.19313 8.899 1.48225 8.68862 0.88 8.35725C0.88 8.371 0.88 8.38888 0.88 8.40675C0.88 10.5985 2.44337 12.419 4.4935 12.8384C4.12637 12.9388 3.72625 12.9869 3.311 12.9869C3.02225 12.9869 2.73075 12.9704 2.45712 12.9099C3.0415 14.696 4.69975 16.0091 6.6715 16.0518C5.137 17.2521 3.18863 17.9754 1.07938 17.9754C0.7095 17.9754 0.35475 17.9589 0 17.9135C1.99787 19.2019 4.36562 19.9375 6.919 19.9375C15.2185 19.9375 19.756 13.0625 19.756 7.10325C19.756 6.90387 19.7491 6.71138 19.7395 6.52025C20.6346 5.885 21.3867 5.09162 22 4.17863Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_47543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgTwitter);
export default __webpack_public_path__ + "static/media/orgTwitter.3667cc203a93aae88fd5d5bd3dc70ca3.svg";
export { ForwardRef as ReactComponent };